import React from 'react';

interface PasswordValidationResult {
  isValid: boolean;
  errors: string[];
}

export const validatePassword = (password: string): PasswordValidationResult => {
  const errors: string[] = [];
  
  if (password.length < 8) {
    errors.push('Password must be at least 8 characters long');
  }
  
  if (!/[A-Z]/.test(password)) {
    errors.push('Password must contain at least one uppercase letter');
  }
  
  if (!/[a-z]/.test(password)) {
    errors.push('Password must contain at least one lowercase letter');
  }
  
  if (!/\d/.test(password)) {
    errors.push('Password must contain at least one number');
  }
  
  if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
    errors.push('Password must contain at least one special character (!@#$%^&*(),.?":{}|<>)');
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
};

interface PasswordRequirementsProps {
  className?: string;
}

export const PasswordRequirements: React.FC<PasswordRequirementsProps> = ({ className }) => {
  return (
    <div className={`mt-1 text-sm text-gray-500 ${className || ''}`}>
      <p className="font-medium mb-1">Password must meet the following criteria:</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>At least 8 characters long</li>
        <li>At least one uppercase letter</li>
        <li>At least one lowercase letter</li>
        <li>At least one number</li>
        <li>At least one special character (!@#$%^&*(),.?":{}|&lt;&gt;)</li>
      </ul>
    </div>
  );
};
